export const BILLING_SORT_BY = {
  UNPAID_FIRST: "UNPAID",
  CREATED_LATEST_FIRST: "RECENTLY_CREATED",
  CREATED_OLDEST_FIRST: "PREVIOUSLY_CREATED",
} as const;

export const billingInvoiceSortOptions = [
  {
    id: 1,
    title: "Unpaid first",
    value: "Unpaid first",
    sortKey: BILLING_SORT_BY.UNPAID_FIRST,
  },
  {
    id: 2,
    title: "Latest first",
    value: "Latest first",
    sortKey: BILLING_SORT_BY.CREATED_LATEST_FIRST,
  },
  {
    id: 3,
    title: "Oldest first",
    value: "Oldest first",
    sortKey: BILLING_SORT_BY.CREATED_OLDEST_FIRST,
  },
];
